angular
  .module('library')

  .controller('LibraryPdfEditCtrl', [
    '$scope',
    '$controller',
    '$stateParams',
    'PdfCrud',
    'PdfModel',
    '$filter',
    'Confirm',
    '$state',
    'ValueLang',
    '$timeout',
    'Dialog',

    function(
      $scope,
      $controller,
      $stateParams,
      PdfCrud,
      PdfModel,
      $filter,
      Confirm,
      $state,
      ValueLang,
      $timeout,
      Dialog
    ) {
      $scope.id = $stateParams.id;

      if (!$scope.id) {
        $scope.errorMessage = 'Pdf not present';
        return;
      }

      var crud = new PdfCrud();
      var confirm = new Confirm();
      var dialog = new Dialog();

      $controller('EditBaseCtrl', {
        $scope: $scope,
        crud: crud,
        object: PdfModel,
        packageName: 'pdf',
        dataName: 'pdf',
        formName: 'pdfForm'
      });

      $controller('DeleteBaseCtrl', {
        $scope: $scope,
        crud: crud,
        packageName: 'pdf',
        dataName: 'pdf'
      });

      $scope.processLoading().then(function(response) {
        $scope.errorMessage = response._id ? undefined : 'Error pdf';

        $scope.name_it = ValueLang($scope.pdf, 'name', 'it');
        $scope.name_en = ValueLang($scope.pdf, 'name', 'en');
        $scope.desc_it = ValueLang($scope.pdf, 'description', 'it');
        $scope.desc_en = ValueLang($scope.pdf, 'description', 'en');
        $scope.abbr_it = ValueLang($scope.pdf, 'abbreviation', 'it');
        $scope.abbr_en = ValueLang($scope.pdf, 'abbreviation', 'en');

        //console.log('$scope.pdf', $scope.pdf);
      });

      $scope.save = function() {
        $scope.processSaving().then(function() {
          $state.go('root.app.simple.libraries', { table: 'pdf' });
        });
      };

      $scope.delete = function() {
        confirm
          .warning($filter('translate')('dialog.DELETE_ASK'))
          .then(function() {
            $scope.processRemoving().then(function() {
              $state.go('root.app.simple.libraries', { table: 'pdf' });
            });
          });
      };

      $scope.getLatest = function(units) {
        if (units && units[0] && units[0].list) {
          var date = units[0].list.dateStart;
          units.forEach(function(unit) {
            date =
              unit.list && unit.list.dateStart > date
                ? unit.list.dateStart
                : date;
          });
          return date;
        }
      };

      $scope.today = new Date();
    }
  ]);
